import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { AppConfigService } from '@core/index';
import { Image } from '@shared/types';

import { ImageSizeDirectiveEvent } from './image-size.directive.types';

@Component({
  selector: 'jb-image-container',
  templateUrl: './image-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageContainerComponent {
  @Input('image') image: Image[];
  hasImageHeightWidthAttr = false;
  enableLazyLoadImage: boolean;
  placeholderParams: string;
  realAspectRatio: number[] = [];

  constructor(
    private appConfig: AppConfigService,
    private cdr: ChangeDetectorRef,
  ) {
    this.hasImageHeightWidthAttr = this.appConfig.imageHeightWidthAttr;
    this.enableLazyLoadImage = this.appConfig.lazyLoadImages;
    this.placeholderParams = this.appConfig.paths[0].placeholderImageParams;
  }

  onImageLoad(event: ImageSizeDirectiveEvent, i: number) {
    this.realAspectRatio[i] = event.aspectRatio;
    this.cdr.detectChanges();
  }
}

export const imageContainerResolver = (registry, data) => ({
  image: data.image,
});
